import { render, staticRenderFns } from "./InputTablesView.vue?vue&type=template&id=3c9c1d08"
import script from "./InputTablesView.vue?vue&type=script&lang=js"
export * from "./InputTablesView.vue?vue&type=script&lang=js"
import style0 from "./InputTablesView.vue?vue&type=style&index=0&id=3c9c1d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports